/*eslint-disable*/
import React, { lazy, Suspense } from "react";

// core components
import Heading from "components/Heading/Heading.js";

const CustomerFlow = lazy(() => import("./CustomerFlow"));
const ClientCounts = lazy(() => import("./ClientCounts"));

import { Grid } from "@mui/material";
import withTimer from "../../components/Timer/withTimer";
import { BRANCH_NAME, COMPANY_NAME } from "../../scripts/const";
import CountBarChart from "./CountBarChart";
import CountPieChart from "./CountPieChart";
import InsightsBarChart from "./InsightsBarChart";
import { useMediaQuery } from "react-responsive";
import RankingTable from "./RankingTable";
import ClientBarChart from "./ConvertTotalClient";
import { useDahboardQuery } from "api/dashboard";
import AnnouncementsTable from "views/GeneralUserDashboard/Announcement";

const Dashboard = () => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const { data, isLoading } = useDahboardQuery();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Heading
        textAlign="center"
        category=""
        title={`${COMPANY_NAME} - ${BRANCH_NAME}`}
      />
      <div>
        <Suspense fallback={<></>}>
          <ClientCounts counts={data?.counts} />
        </Suspense>

        {!isTabletOrMobile && (
          <Suspense fallback={<></>}>
            <Grid container spacing={3}>
              <Grid item xs={7}>
                <CustomerFlow />
              </Grid>
              <Grid
                item
                xs={5}
                sx={{
                  marginTop: "30px",
                }}
              >
                <RankingTable />
              </Grid>
            </Grid>
          </Suspense>
        )}
        <Suspense fallback={<></>}>{<ClientBarChart />}</Suspense>
        {!isTabletOrMobile && (
          <Suspense fallback={<></>}>{<CountBarChart />}</Suspense>
        )}

        <Suspense fallback={<></>}>{<CountPieChart />}</Suspense>
        {!isTabletOrMobile && (
          <Suspense fallback={<></>}>{<InsightsBarChart />}</Suspense>
        )}
        <Suspense fallback={<></>}>
          <AnnouncementsTable />
        </Suspense>
      </div>
    </div>
  );
};

export default withTimer(Dashboard);
